import { bikerState } from '../type';

const toggleSelectedItem = (state: bikerState, id: string): bikerState => {
  if (state?.selectedItem.some((orderItem) => orderItem === id)) {
    return {
      ...state,
      selectedItem: state?.selectedItem.filter((x) => x !== id),
    };
  }
  return {
    ...state,
    selectedItem: [...(state?.selectedItem || []), id],
  };
};

export default toggleSelectedItem;
